/** The live "new pre-order" alert, and the offer to install the app. */
const alerts = {
  en: {
    newOrder: {
      title: "New pre-order",
      customer: "A customer",
      pickup: "Pickup: {day}, {time}",
      view: "View orders",
      dismiss: "Got it",
      soundOn: "Sound on — tap to mute",
      soundOff: "Sound off — tap to turn on",
    },
    install: {
      title: "Add the register to this device",
      android: "It opens full screen and keeps working when the connection drops.",
      ios: "Tap “Share”, then “Add to Home Screen”.",
      install: "Install",
      notNow: "Not now",
    },
  },

  fr: {
    newOrder: {
      title: "Nouvelle précommande",
      customer: "Un client",
      pickup: "Retrait : {day}, {time}",
      view: "Voir les commandes",
      dismiss: "Compris",
      soundOn: "Son activé — touchez pour couper",
      soundOff: "Son coupé — touchez pour l'activer",
    },
    install: {
      title: "Installer la caisse sur cet appareil",
      android:
        "Elle s'ouvre en plein écran et continue de fonctionner quand la connexion coupe.",
      ios: "Touchez « Partager », puis « Sur l'écran d'accueil ».",
      install: "Installer",
      notNow: "Plus tard",
    },
  },

  ar: {
    newOrder: {
      title: "طلب مسبق جديد",
      customer: "زبون",
      pickup: "الاستلام: {day}، الساعة {time}",
      view: "عرض الطلبات",
      dismiss: "حسناً",
      soundOn: "الصوت مفعّل — اضغط للكتم",
      soundOff: "الصوت مكتوم — اضغط للتفعيل",
    },
    install: {
      title: "ثبّت نقطة البيع على هذا الجهاز",
      android: "تفتح بملء الشاشة وتواصل العمل عند انقطاع الاتصال.",
      ios: "اضغط «مشاركة» ثم «إضافة إلى الشاشة الرئيسية».",
      install: "تثبيت",
      notNow: "لاحقاً",
    },
  },
};

export default alerts;
